import React, { useEffect, useState } from "react";
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./ReportBonus.css";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import M from "materialize-css";
import $ from "jquery";

import banner1 from "../logo.svg";
import { API_URL, numberWithCommas } from "../constant";

import jwt from "jsonwebtoken";
import HeaderBack from "../layout/HeaderBack";

import Select from "react-select";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import Stack from "@mui/material/Stack";
import { Backdrop, CircularProgress } from "@mui/material";

const ChallengeAchievement = () => {
  const [token, setToken] = useLocalStorage("token", "");
  const [achievement, setAchievement] = useState([]);
  const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

  const notify = () => toast.error("Something went wrong!");

  function getChallengeAchievement() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/profile/challengeachievement`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  useEffect(async () => {
    setIsOpenBackdrop(true);
    let responseAchievement = await getChallengeAchievement();
    if(responseAchievement.status == 200 && responseAchievement.data){
        setAchievement(responseAchievement.data);
    }
    setIsOpenBackdrop(false);
  }, []);

  return (
    <React.StrictMode>
      <Toaster position="bottom-center" />
      <HeaderBack title="Challenge Achievement" />
      <div className="">
        <div className="row" style={{ marginTop: "15px" }}>
          <div className="row">
            <div className="col s12">
              <table className="table" id="table-report">
                <thead>
                  <tr>
                    <th>Member Code</th>
                    <th>Member Name</th>
                    <th>Ticket 1</th>
                    <th>Ticket 2</th>
                    <th>Ticket 3</th>
                  </tr>
                </thead>
                <tbody>
                  {achievement.map((val, idx) => {
                    return (
                      <tr>
                        <td>{val.MemberCode}</td>
                        <td>{val.MemberName}</td>
                        <td>{val.Ticket1}</td>
                        <td>{val.Ticket2}</td>
                        <td>{val.Ticket3}</td>
                      </tr>
                    );
                  })}
                  {achievement.length == 0 ? (
                    <tr>
                      <td colSpan={5} className="center-align">
                        No record found!
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpenBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.StrictMode>
  );
};

export default ChallengeAchievement;
